import React from "react";

/* layouts */
import AboutUsCompany from "../layouts/AboutUsCompany";
import Mvv from "../layouts/Mvv";
import MemberCarousels from "../layouts/MemberCarousels";
import Partners from "../layouts/Partners";

const membersData = {
  diretores: [
    {
      name: "Bernardo Rodrigues",
      role: "Presidente",
      image: require("../assets/Membros/Atual/Bernardo_Rodrigues.jpeg"),
      linkedin: "https://www.linkedin.com/in/bernardo-rodrigues-568349340/",
      github: "https://github.com/Sentessh",
    },
    {
      name: "Pedro Henrique",
      role: "Diretor de Projetos",
      image: require("../assets/Membros/Atual/PedroHenrique.jpg"),
      linkedin: "https://www.linkedin.com/in/pedrohldev",
      github: "https://github.com/phladev",
    },
    {
      name: "André Lucas",
      role: "Diretor de Gestão",
      image: require("../assets/Membros/Atual/Andre.jpg"),
      linkedin: "https://www.linkedin.com/in/andrelucascunhadealmeida",
    },
    {
      name: "Ester Maria",
      role: "Diretora Comercial",
      image: require("../assets/Membros/Atual/Ester_Maria.jpeg"),
      linkedin: "https://www.linkedin.com/in/ester-maria-souza/",
      github: "https://github.com/estermariaa",
    },
    {
      name: "Rebeca Martins",
      role: "CM",
      image: require("../assets/Membros/Atual/Rebeca.jpg"),
      linkedin:
        "https://www.linkedin.com/in/rebeca-martins-guimar%C3%A3es-37b235336/",
      github: "https://github.com/Rebeca-Martins1",
    },
  ],
  setorProjetos: [
    {
      name: "Brian Alves",
      role: "Assessor de Projetos (Dados)",
      image: require("../assets/Membros/Atual/Braian.jpg"),
      linkedin: "https://www.linkedin.com/in/brian-alves/",
      github: "https://github.com/Project-Nyar",
    },
    {
      name: "Carlos Gabriel",
      role: "Assessor de Projetos (Web)",
      linkedin: "https://www.linkedin.com/in/carlos-gabriel-3519a2364/",
      github: "https://github.com/Gabrielz-teix",
    },
    {
      name: "João Pedro",
      role: "Assessor de Projetos (Web)",
      image: require("../assets/Membros/Atual/JoaoPedro.jpg"),
      linkedin: "https://www.linkedin.com/in/jo%C3%A3opedro135/",
      github: "https://github.com/joaopedro135",
    },
    {
      name: "José Vitor",
      role: "Assessor de Projetos (Web)",
      image: require("../assets/Membros/Atual/JoseVitor.jpg"),
      linkedin: "https://www.linkedin.com/in/josé-vitor-santos-alves-1540b831a",
      github: "https://github.com/JoseVitor2004",
    },
    {
      name: "Lara Caroline",
      role: "Assessora de Projetos (Dados)",
      image: require("../assets/Membros/Atual/Lara.jpg"),
      linkedin: "https://www.linkedin.com/in/lara-silva-9275a7352",
      github: "https://github.com/LaraCSilva",
    },
    {
      name: "Leonardo Torres",
      role: "Assessor de Projetos (Web)",
      image: require("../assets/Membros/Atual/LeonardoTorres.jpg"),
      linkedin:
        "https://www.linkedin.com/in/leonardo-torres-gonçalves-e-silva-835849250/",
      github: "https://github.com/LeoTorresGon",
    },
    {
      name: "Marlon Silveira",
      role: "Assessor de Projetos (Dados)",
      linkedin: "https://www.linkedin.com/in/marlonsbas/",
      github: "https://github.com/marlonsbasilio",
    },
    {
      name: "Matheus Soares",
      role: "Assessor de Projetos (Dados)",
      linkedin:
        "https://www.linkedin.com/in/matheus-soares-9242972b8?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app",
    },
    {
      name: "Vitor Luiz",
      role: "Assessor de Projetos (Web)",
      image: require("../assets/Membros/Atual/VitorLuiz.jpg"),
      linkedin:
        "https://www.linkedin.com/in/vitor-luiz-reis-do-carmo-631340265/",
      github: "https://github.com/V1torL",
    },
    {
      name: "Braian Melo",
      role: "Assessor de Projetos (Web)",
      linkedin: "www.linkedin.com/in/braian-melo-a6855a32b",
      github: "https://github.com/BraianMelo ",
    },
  ],
  setorComercial: [
    {
      name: "Augusto Cézar",
      role: "Assessor Comercial (Vendas)",
    },
    {
      name: "Bernardo Maturana",
      role: "Assessor Comercial (Vendas)",
    },
    {
      name: "Bernardo Ribeiro",
      role: "Assessor Comercial (Vendas)",
    },
    {
      name: "Daniel Francisco",
      role: "Assessor Comercial (Vendas)",
    },
    {
      name: "Guilherme Garcia",
      role: "Assessor Comercial (Vendas)",
    },
    {
      name: "João Vitor Sant'Anna",
      role: "Assessor Comercial (Marketing)",
    },
    {
      name: "Lucas de Oliveira",
      role: "Assessor Comercial (Marketing)",
    },
    {
      name: "Lucas Ferreira",
      role: "Assessor Comercial (Vendas)",
      image: require("../assets/Membros/Atual/LucasFerreira.jpg"),
      linkedin: "http://www.linkedin.com/in/lucasferst13",
      github: "https://github.com/lvcas13",
    },
    {
      name: "Mateus Cristiano",
      role: "Assessor Comercial (Vendas)",
    },
    {
      name: "Rafael Carvalho",
      role: "Assessor Comercial (Marketing)",
      linkedin: "https://www.linkedin.com/in/rafael-avidago/",
    },
    {
      name: "Yasmin Ferreira",
      role: "Assessor Comercial (Marketing)",
    },
  ],
  setorGestao: [
    {
      name: "Gabriel de Paula",
      role: "Assessor de Gestão",
    },
    {
      name: "Oscar Alves",
      role: "Assessor de Gestão",
      image: require("../assets/Membros/Atual/Oscar.jpg"),
      linkedin: "https://www.linkedin.com/in/oscar-alves-11ab00172/",
    },
    {
      name: "Vinícius de Paiva",
      role: "Assessor de Gestão",
    },
  ],
  posJuniores: [
    {
      name: "Adélson de Oliveira",
      role: "Ex-Assessor de Projetos",
      linkedin:
        "https://www.linkedin.com/in/ad%C3%A9lson-j%C3%BAnior-85a970327/",
      image: require("../assets/Membros/Pós_Juniores/Adelson.jpg"),
    },
    {
      name: "Alan Vale",
      role: "Ex-Assessor de Projetos",
      image: require("../assets/Membros/Atual/Alan.jpg"),
      linkedin: "https://www.linkedin.com/in/alan-vale-ba432324a/",
      github: "https://github.com/alaanvv",
    },
    {
      name: "Bernardo Detomi",
      role: "Ex-Assessor de Projetos",
      image: require("../assets/Membros/Atual/BernardoMaia.jpg"),
      linkedin: "https://www.linkedin.com/in/bernardo-maia-detomi-7621a51b9/",
      github: "https://github.com/BernardoDetomi",
    },
    {
      name: "Bruno Costa",
      role: "Ex-Gerente de Web",
      image: require("../assets/Membros/Atual/Bruno.jpg"),
      linkedin: "https://www.linkedin.com/in/bruno-oliveira-82883129b/",
      github: "https://github.com/vxreal",
    },
    {
      name: "Gabriel Gomes",
      role: "Ex-Assessor de Projetos",
      linkedin: "https://www.linkedin.com/in/gabriel-gomes-47780b207/",
      image: require("../assets/Membros/Pós_Juniores/GabrielGomes.jpg"),
    },
    {
      name: "Júlia Nunes",
      role: "Ex-Assessora de Projetos",
      image: require("../assets/Membros/Atual/JuliaNunes.jpg"),
      linkedin: "https://www.linkedin.com/in/julia-nunes-a50674217",
      github: "https://github.com/julianunes2703",
    },
    {
      name: "Renan Rodrigues",
      role: "Assessor de Projetos (dados)",
      linkedin: "https://www.linkedin.com/in/renan-sousa-9457a9162/",
      github: "https://github.com/Renan-Sousa",
      image: require("../assets/Membros/Atual/Renan.jpg"),
    },
    {
      name: "Vitor José",
      role: "Ex-Assessor de Projetos",
      image: require("../assets/Membros/Pós_Juniores/Vitor_José.jpg"),
    },
    {
      name: "Vitor Niess",
      role: "Ex-Assessor de Projetos",
      image: require("../assets/Membros/Atual/Vitor_Niess.jpg"),
      linkedin: "https://www.linkedin.com/in/vitorniess/",
    },
    {
      name: "Matheus de Oliveira",
      role: "Ex-Assessor de Marketing",
      image: require("../assets/Membros/Pós_Juniores/Matheus.jpg"),
      linkedin: "https://www.linkedin.com/in/mateuso-brito/",
    },
    {
      name: "Antônio Gustavo",
      role: "Ex-Gerente de Vendas",
      image: require("../assets/Membros/Pós_Juniores/Antonio.jpg"),
    },
    {
      name: "Leonardo Patias",
      role: "Ex-Assessor de Vendas",
      image: require("../assets/Membros/Pós_Juniores/Leonardo.jpg"),
    },
    {
      name: "Luiz Filipe",
      role: "Ex-Assessor de Projetos",
      image: require("../assets/Membros/Pós_Juniores/Luiz_Felipe.jpg"),
    },
    {
      name: "Elias Mendes",
      role: "Ex-Assessor de Projetos",
      image: require("../assets/Membros/Pós_Juniores/Elias.jpg"),
      linkedin: "https://www.linkedin.com/in/elias-m-1390b2141/",
    },
    {
      name: "Nathan Mateus",
      role: "Ex-Assessor de Projetos",
      linkedin: "https://linkedin.com/in/nathan-lima-aa56ba312/",
    },
    {
      name: "João Antônio",
      role: "Ex-Presidente 2024",
      image: require("../assets/Membros/Pós_Juniores/Joao_Antonio_ex_Linked.png"),
      linkedin: "https://www.linkedin.com/in/scjoaoantonio/",
      github: "https://github.com/scjoaoantonio",
    },
    { name: "Lívia Maia", role: "Ex-Assessora de Gestão" },
    {
      name: "Ian Nunes",
      role: "Ex-Assessor de Projetos",
      linkedin: "https://www.linkedin.com/in/ian-nunes-379686266/",
    },
    {
      name: "Dilvonei Alves",
      role: "Ex-Assessor de Projetos",
      image: require("../assets/Membros/Pós_Juniores/Dilvonei.jpg"),
      linkedin: "https://www.linkedin.com/in/dilvonei-alves-lacerda-05328a228/",
      github: "https://github.com/DilvoneiL",
    },
    {
      name: "Davi Greco",
      role: "Ex-Assessor de Projetos",
      image: require("../assets/Membros/Pós_Juniores/Davi_Greco.jpg"),
      linkedin: "https://www.linkedin.com/in/davi-greco-4285b9275/",
      github: "https://github.com/DaviGreco",
    },
    {
      name: "Davi Gomes",
      role: "Ex-Assessor de Projetos",
      image: require("../assets/Membros/Pós_Juniores/Davi_Gomes.jpg"),
      linkedin: "https://www.linkedin.com/in/davi-gomes-coelho-49b24a184",
      github: "https://github.com/davigpc",
    },
    {
      name: "Marco Aurélio",
      role: "Ex-Assessor de Gestão",
      image: require("../assets/Membros/Pós_Juniores/Marcu.jpg"),
      linkedin: "https://www.linkedin.com/in/marcoquaglietta/",
    },
    {
      name: "Ana Júlia",
      role: "Ex-Assessora de Marketing",
      image: require("../assets/Membros/Pós_Juniores/Julia.jpg"),
      linkedin: "https://www.linkedin.com/in/ana-julia-silva-ledo-b8386828a",
      github: "https://github.com/julialedo",
    },
    {
      name: "Guilherme Anicio",
      role: "Ex-Assessor Comercial",
      image: require("../assets/Membros/Pós_Juniores/Guilherme_Sasa.jpg"),
      linkedin: "https://www.linkedin.com/in/guilherme-m-anicio/",
    },
    {
      name: "Thaís Apolinário",
      role: "Ex-Assessora Comercial",
      image: require("../assets/Membros/Pós_Juniores/Thais_Apolinario.jpg"),
      linkedin:
        "https://www.linkedin.com/in/tha%C3%ADs-apolin%C3%A1rio-196994259/",
    },
    {
      name: "Lucas Leite",
      role: "Ex-Diretor de Comercial 2024",
      image: require("../assets/Membros/Pós_Juniores/Lucas_Costa.png"),
      linkedin: "http://www.linkedin.com/in/lucas-leite-888953299",
      github: "https://github.com/lucaselc",
    },
    {
      name: "Lucas Bernardes",
      role: "Ex-Diretor de Gestão 2024",
      image: require("../assets/Membros/Pós_Juniores/Lucas_Bernardes.jpg"),
      linkedin:
        "https://www.linkedin.com/in/lucas-eduardo-bernardes-de-paula-5615b7256/",
      github: "https://github.com/LucasBernardess",
    },
    {
      name: "André Chagas",
      role: "Ex-Diretor de Projetos 2024",
      image: require("../assets/Membros/Pós_Juniores/Andre_Chagas.jpg"),
      github: "https://github.com/andrechagaslima",
    },
    { name: "Gustavo Romão", role: "Ex-Presidente 2023" },
    {
      name: "Rafael Marques",
      role: "Ex-Presidente 2022",
      image: require("../assets/Membros/Pós_Juniores/Rafael_Marques.jpeg"),
      linkedin: "https://www.linkedin.com/in/rafael-campos-656559217/",
      github: "https://github.com/Markesxd",
    },
    {
      name: "Douglas José",
      role: "Ex-Assessor de Projetos",
      image: require("../assets/Membros/Pós_Juniores/Douglas_José_Barboza.jpg"),
      linkedin: "https://www.linkedin.com/in/douglasjosebarboza/",
      github: "https://github.com/douglasjosebarboza",
    },
    {
      name: "Paulo Eduardo",
      role: "Ex-Diretor de Projetos 2023",
      image: require("../assets/Membros/Pós_Juniores/Paulo.jpg"),
    },
    {
      name: "Joice Cristina",
      role: "Ex-Representante de Projetos",
      image: require("../assets/Membros/Pós_Juniores/Joice_Cristina.jpeg"),
      linkedin: "https://www.linkedin.com/in/joicecssantos/",
      github: "https://github.com/Joice-crypto",
    },
  ],
};

const Company = () => {
  return (
    <>
      <AboutUsCompany />
      <Mvv />
      <Partners />
      <MemberCarousels members={membersData} />
    </>
  );
};

export default Company;
